import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on APPS
  fetchVersions: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchVersions';

    commit(`${mutationPrefix}Pending`);

    return api.fetchVersions(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on APPS
  fetchSingleVersion: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSingleVersion';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSingleVersion(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CUSTOM mutations on POLICIES
  revertVersion: (context, requestParams) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'revertVersion';

    commit(`${mutationPrefix}Pending`);

    return api.revertVersion(requestParams)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openDiffModal: ({ commit }, payload = null) => {
    commit('openDiffModal', payload);
  },

  closeDiffModal: ({ commit }) => {
    commit('closeDiffModal');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/version/actions.js